import { render, staticRenderFns } from "./FormCandidate.vue?vue&type=template&id=0331af54"
import script from "./FormCandidate.vue?vue&type=script&lang=js"
export * from "./FormCandidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormCandidate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0331af54')) {
      api.createRecord('0331af54', component.options)
    } else {
      api.reload('0331af54', component.options)
    }
    module.hot.accept("./FormCandidate.vue?vue&type=template&id=0331af54", function () {
      api.rerender('0331af54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/candidates/components/FormCandidate.vue"
export default component.exports